import * as React from 'react';
import { IconButton } from '../../IconButton';
import { Close } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './CloseIconButton.deprecated.st.css';
export const CloseIconButton = function (props) {
    return React.createElement(IconButton, { icon: React.createElement(Close, null), ...props, className: classes.root });
};
//# sourceMappingURL=CloseIconButton.js.map